<template>
  <div class="outBox">
    <div class="box">
      <div v-loading="loading" element-loading-text="加载数据中"
           element-loading-spinner="el-icon-loading"
           element-loading-background="rgba(0, 0, 0, 0.2)"
           class="mine"></div>
      <div id="EchartsLine" class="chart-container"></div>
    </div>
  </div>

</template>

<script>
import * as echarts from 'echarts';
import { getTrendList } from '@/api/bi'


export default {
  name: "echartsNine",
  data(){
    return {
      chart: null,
      loading: false, // 控制加载效果的显示与隐藏
      lineData: {},
    }
  },
  props: ['params'],
  mounted() {
    this.chart = echarts.init(document.getElementById('EchartsLine'))
    // this.initBar(this.params[0])
    this.loading = true
  },
  watch: {
    params: function (val, oldVal) {
      this.initBar(val[0])
    }
  },
  methods:{
    initBar(row){
      this.loading = true
      const _this = this;
      const text = '';

      let option = {
        title: {
          text,
          color: '#fff',
          top: 16,
          left: 'center',
          textStyle:{
            fontSize: 18,
            fontWeight: 'bold',
            color: '#fff',
          }
        },
        // 更改图例默认颜色(依次应用)
        color:['rgb(0, 255, 255, 10)', 'rgb(140, 231, 133, 10)', 'rgb(245, 226, 0, 10)'],
        tooltip: { // 数据展示框
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          formatter: function(params) {
            console.log(123, params)
            let str = '';
            str += params[0].axisValue + '<br />'
            str += '景区:' + params[0].data.company + '<br />'
            let spacespan =`<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params[0].color};"></span>`;
            str += spacespan + params[0].seriesName + "：" + params[0].value.toFixed(2) + '<br />'
            return str
          }
        },
        grid: {
          left: '5%',
          right: '10%',
          bottom: '15%',
          containLabel: true
        },
        legend: {
          data: [
            {
              name: '各景区利润(¥)',
              textStyle: {
                color: '#FFF'          // 图例文字颜色
              }
            },
          ],
          right: 50,
          top: 20,
        },
        xAxis: {
          name: '景区排名',
          type: 'category',
          axisLabel: {
            inside: false, // y轴名字是否显示在柱状图里面
            zlevel: 2,
            color: '#fff' // y轴名字颜色
          },
          axisTick: {
            show: true
          },
          axisLine: {
            show: true,
            // 坐标轴轴线相关设置。
            lineStyle: {
              color: '#fff'
            }
          },
          data: row.chart_data.x_axis
        },
        yAxis: [
          {
            name: '累计利润(¥)',
            type: 'value',
            axisLine: {
              show: true,
              // 坐标轴轴线相关设置。
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {  // 坐标轴上的文字
              color: '#fff',
              formatter: function (value, index) {
                return value;
              }
            },
            axisTick:{ // 坐标轴刻度线
              show:false
            },
            splitLine:{
              show:false // 不显示网格线
            },
          }
        ],
        dataZoom: [
          {
            type: 'slider',
            start: 0, //数据窗口范围的起始百分比0-100。
            end: 100, //数据窗口范围的结束百分比0-100。
            textStyle: { 
                  color: '#FFF'
                },
          },
          // {
          //   type: 'inside', // 支持滚轮缩放
          // },
        ],
        series: [
          {
            name: '累计利润(¥)',
            legendHoverLink: false,
            // ------------------数据及其样式----------------------------
            // 内柱条的数据
            data: row.ranking_details.map(item => ({
              value: item.cumulative_profit,
              company: item.company
            })),
            type: 'line',
            smooth: true,
            lineStyle: { // 线条样式
              normal: {
                width: 4,
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [ // 颜色渐变
                  {
                    offset: 0,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 0.2,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 0.4,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.6,
                    color: 'rgb(0, 200, 200, 80)'
                  },
                  {
                    offset: 0.8,
                    color: 'rgb(0, 255, 255, 10)'
                  },
                  {
                    offset: 1,
                    color: 'rgb(0, 255, 255, 10)'
                  }
                ])
              }
            }

          }
        ],


      };

      // 使用刚指定的配置项和数据显示图表。
      this.chart.setOption(option);
      // // 隐藏加载效果
      // setTimeout(()=> {
      //   this.loading = false;
      // }, 2000)
      this.loading = false
    },
  },
}
</script>

<style scoped>
.outBox {
  width: 100%;
  height: 620px;
  /*border: 1px solid #4688ff;*/
}

.box {
  width: 100%;
  height: 620px; /* 与组件中的高度一致 */
  position: relative;
}

.mine {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
  position: absolute;
  top: 0;
  left: 0;
}

.chart-container {
  width: 100%;
  height: 100%; /* 与组件中的高度一致 */
}


</style>